module.exports = __webpack_public_path__ + "static/media/mindy_clipboard_physician 2.e644fe9f.png";